import loadable from "@loadable/component";
import APIS from "../../constant/Endpoint";
import useGetHook from "../../customHooks/useGetHook";
import usePostHook from "../../customHooks/usePostHook";

const CreateSmsCampaignComponent = loadable(
  () =>
    import("../../components/SmsCampaign/SmsCampaignCreate/SmsCampaignCreate")
);
const CreateSmsCampaign = () => {
  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["sms-campaign"],
  });

  const { refetch } = useGetHook({
    queryKey: ["sender-contacts"],
    url: APIS.SENDER_SMS,
    params: {
      is_default: true,
    },
  });

  const handleCreate = async (values: any, setError: any, isDraft: boolean) => {
    const url = APIS.SMS_CAMPAIGN;
    const formData = {
      ...values,
      is_draft: isDraft,
    };
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <>
      <CreateSmsCampaignComponent
        handleCreate={handleCreate}
        isPostLoading={isPostLoading}
        refetch={refetch}
      />
    </>
  );
};

export default CreateSmsCampaign;
